module.exports = __webpack_public_path__ + "static/media/icon-piece3-1.f6c3672b.png";